<template>
  <div v-if="showFilter" class="legal-entity-filter w-full sm:w-auto" style="min-width: 260px;">
    <label class="text-sm font-medium mb-1 block">{{ label }}</label>
    <v-select
      v-model="selected"
      :options="options"
      :reduce="option => option.id"
      label="name"
      :placeholder="placeholder"
      :clearable="isSystemAdmin"
      @input="handleChange"
      class="w-full"
    >
    </v-select>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { mapGetters } from 'vuex'

export default {
  name: 'LegalEntityFilter',
  components: {
    vSelect
  },
  props: {
    value: {
      type: Object,
      default: () => ({ legal_entity_id: null })
    },
    label: {
      type: String,
      default: 'Pessoa Jurídica'
    }
  },
  data() {
    return {
      selected: null
    }
  },
  computed: {
    ...mapGetters('dataAccess', [
      'entities',
      'activeEntity',
      'isSystemAdmin',
      'loaded'
    ]),
    showFilter() {
      if (this.isSystemAdmin) {
        return this.entities.length > 0
      }
      return this.entities.length > 1
    },
    placeholder() {
      return this.isSystemAdmin ? 'Todas' : 'Selecione'
    },
    options() {
      return this.entities.map(entity => ({
        id: entity.id,
        name: this.formatName(entity)
      }))
    }
  },
  methods: {
    formatName(entity) {
      if (entity.name) {
        return entity.name
      }
      const label = `${entity.trading_name || ''} - ${entity.company_name ||
        ''}`.trim()
      return label === '-' ? `ID: ${entity.id}` : label
    },
    resolveDefault() {
      if (this.isSystemAdmin) {
        return this.activeEntity ? this.activeEntity.id : null
      }
      if (this.entities.length === 0) {
        return null
      }
      if (this.activeEntity) {
        return this.activeEntity.id
      }
      const head = this.entities.find(entity => entity.head)
      return (head || this.entities[0]).id
    },
    handleChange() {
      this.emitChange()
    },
    emitChange() {
      const payload = { legal_entity_id: this.selected || null }
      this.$emit('input', payload)
      this.$emit('change', payload)
    },
    onActiveLegalEntityChanged() {
      this.selected = this.resolveDefault()
      this.emitChange()
    },
    async setup() {
      if (!this.loaded) {
        await this.$store.dispatch('dataAccess/setupFromLogin')
      }
      this.selected = this.resolveDefault()
      this.$nextTick(() => {
        this.emitChange()
      })
    }
  },
  mounted() {
    this.$root.$on('activeLegalEntityChanged', this.onActiveLegalEntityChanged)
    this.setup()
  },
  beforeDestroy() {
    this.$root.$off('activeLegalEntityChanged', this.onActiveLegalEntityChanged)
  }
}
</script>

<style scoped>
.legal-entity-filter {
  width: 100%;
}
</style>
